import { createContext } from '@wordpress/element';
const ToolbarContext = createContext(undefined);
ToolbarContext.displayName = 'ToolbarContext';
export default ToolbarContext;